export const IFRAME_CONTAINER_ID = 'mfe-container';
export const IFRAME_HEIGHT = '320px';
export const IFRAME_LOADING_TIMEOUT = 50000; // 50 seconds
export const MFE_NAME = 'ccPayment';
export const MFE_TITLE = 'QBE Digital Payment';

export enum MessageType {
  MFE_INIT = 'QBE-PAYMENTMFE/init',
  CC_FORM_INIT = 'QBE-PAYMENTMFE/cc-form-init',
  CC_FORM_VALID = 'QBE-PAYMENTMFE/cc-form-valid',
  CC_FORM_EXPIRED = 'QBE-PAYMENTMFE/cc-form-expired',
  PAYMENT_STATUS = 'QBE-PAYMENTMFE/payment-status',
  SUBMIT_CC_FORM = 'QBE-PAYMENTMFE/submit-cc-form',
}

export enum MessageResultType {
  SUCCESS = 'success',
  FAILED = 'failure',
}

export const PAYMENT_TYPE_CREDIT_CARD = 'CC-FORM';
export const SOURCE_SYSTEM = 'QBE-MFE-DIGISME-PAYMENT_V2';
export const ALLOWED_CARDS = ['VISA', 'MASTERCARD', 'AMEX'];
